import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PaletteAppVersionHit, PaletteContainerHit } from './command-palette.model';

// one-shot ES lookups for the paste-an-id support flow — deliberately
// plain HTTP: the results are ephemeral palette rows, they must not
// touch the entity store or create websocket subscriptions
@Injectable({ providedIn: 'root' })
export class CommandPaletteApi {
  #http = inject(HttpClient);

  // `sort` is a REQUIRED field of the EsFilter contract (it validates
  // `field is required` even though [] is a legal value); the clientId
  // filter pins hits to the active organization — without it a multi-org
  // user could get a hit from another org and navigate into a dead route
  searchContainersById$(id: string, clientId: string) {
    return this.#http.post<{ items: PaletteContainerHit[] }>(
      '/api/container/search',
      {
        search: [
          { name: 'clientId', operator: 'eq', value: clientId },
          { name: 'id', operator: 'eq', value: id }
        ],
        sort: []
      }
    );
  }

  searchAppVersionsById$(id: string, clientId: string) {
    return this.#http.post<{ items: PaletteAppVersionHit[] }>(
      '/api/app-version/search',
      {
        search: [
          { name: 'clientId', operator: 'eq', value: clientId },
          { name: 'id', operator: 'eq', value: id }
        ],
        sort: []
      }
    );
  }
}
